function cellKeysEqual(a, b) {
    return a.quantityStageOrder === b.quantityStageOrder && a.yBucket === b.yBucket;
}
function expandTransition(transition, direction) {
    return transition.agents.map((agent) => ({
        agent,
        from: transition.from,
        to: transition.to,
        direction,
    }));
}
export function cellMoversFromTransitions(transitions, cell) {
    const inRows = [];
    const outRows = [];
    for (const transition of transitions) {
        if (cellKeysEqual(transition.to, cell)) {
            inRows.push(...expandTransition(transition, 'in'));
        }
        if (cellKeysEqual(transition.from, cell)) {
            outRows.push(...expandTransition(transition, 'out'));
        }
    }
    return { in: inRows, out: outRows };
}
export function stageMoversFromTransitions(transitions, quantityStageOrder) {
    const inRows = [];
    const outRows = [];
    for (const transition of transitions) {
        if (transition.to.quantityStageOrder === quantityStageOrder) {
            inRows.push(...expandTransition(transition, 'in'));
        }
        if (transition.from.quantityStageOrder === quantityStageOrder) {
            outRows.push(...expandTransition(transition, 'out'));
        }
    }
    return { in: inRows, out: outRows };
}
export function flattenMoverGroups(groups) {
    const seen = new Set();
    const result = [];
    for (const row of [...groups.in, ...groups.out]) {
        if (seen.has(row.agent.groupKey))
            continue;
        seen.add(row.agent.groupKey);
        result.push(row.agent);
    }
    return result;
}
